import ModalVue from './ConfirmModal';
import Vue from 'vue';

let vueDom = null;

const close = () => {
	if (vueDom) {
		document.body.removeChild(vueDom.$el);
		vueDom = null;
	}
}

const Modal = {
	confirm: config => {
		const div = document.createElement('div');
		document.body.appendChild(div);
		vueDom = new Vue({
			render: h => h(ModalVue, {
				props: {
					config,
					close
				}
			})
		}).$mount(div);
	}
}
export default Modal;